document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(".animated-section");
  
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    }, {
      threshold: 0.1, // Trigger when 10% of the section is visible
    });
  
    sections.forEach((section) => observer.observe(section));
});
// Function to initialize a video player
function initVideoPlayer(container) {
  const video = container.querySelector('.custom-video');
  const playPauseBtn = container.querySelector('.play-pause');
  const muteUnmuteBtn = container.querySelector('.muteUnmute');
  const playPauseIcon = playPauseBtn.querySelector('img');
  const muteIcon = muteUnmuteBtn.querySelector('img');



  const playIcon = playPauseBtn.dataset.play;
  const pauseIcon = playPauseBtn.dataset.pause;
  const muteImg = muteUnmuteBtn.dataset.mute;
  const volumeImg = muteUnmuteBtn.dataset.volume;
  
  // playPauseBtn.addEventListener('click', () => {
  //   if (video.paused || video.ended) {
  //     video.play();
  //     playPauseIcon.src = "{{ 'pause.png' | asset_url }}";
  //   } else {
  //     video.pause();
  //     playPauseIcon.src = "{{ 'play-buttton.png' | asset_url }}";
  //   }
  // });
  // muteUnmuteBtn.addEventListener('click', () => {
  //   video.muted = !video.muted;
  //   muteIcon.src = video.muted ? "{{ 'mute.png' | asset_url }}" : "{{ 'volume.png' | asset_url }}";
  // });

  playPauseBtn.addEventListener('click', () => {
    if (video.paused || video.ended) {
      video.play();
      playPauseIcon.src = pauseIcon;
    } else {
      video.pause();
      playPauseIcon.src = playIcon;
    }
  });

  muteUnmuteBtn.addEventListener('click', () => {
    video.muted = !video.muted;
    muteIcon.src = video.muted ? muteImg : volumeImg;
  });
}
// document.querySelectorAll('.video-container').forEach(initVideoPlayer);
// const lightbox = document.getElementById('lightbox');
// const lightboxImage = document.getElementById('lightboxImage');
// const closeBtn2 = document.getElementById('closeBtn');
// const prevBtn = document.getElementById('prevBtn');
// const nextBtn = document.getElementById('nextBtn');
// const images = document.querySelectorAll('.image-containerWrap img');

// let currentIndex = 0;

// // Open Lightbox
// images.forEach((img, index) => {
//     img.addEventListener('click', () => {
//         currentIndex = index;
//         showImage();
//         lightbox.style.display = 'flex';
//     });
// });

// // Show Image in Lightbox
// function showImage() {
//     lightboxImage.src = images[currentIndex].src;
// }

// // Close Lightbox
// closeBtn2.addEventListener('click', () => {
//     lightbox.style.display = 'none';
// });

// // Previous Image
// prevBtn.addEventListener('click', () => {
//     currentIndex = (currentIndex - 1 + images.length) % images.length;
//     showImage();
// });

// // Next Image
// nextBtn.addEventListener('click', () => {
//     currentIndex = (currentIndex + 1) % images.length;
//     showImage();
// });

// // Zoom In/Out
// lightboxImage.addEventListener('click', () => {
//     lightboxImage.classList.toggle('zoomed');
// });

// // Close Lightbox on Background Click
// lightbox.addEventListener('click', (e) => {
//     if (e.target === lightbox) {
//         lightbox.style.display = 'none';
//     }
// });
          
// $('.blogInnerslider').slick({
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     centerMode: true,
//     responsive: [
//             {
//             breakpoint: 768, 
//             settings: {
//                 slidesToShow: 1, 
//                 arrows: false,   
//                 dots: true,
//                 centerMode: false,      
//             }
//             }
//         ]

// });
$('.blogInnerslider').slick({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  centerMode: true,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
        centerMode: true,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerMode: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        arrows: false,
        dots: true
      }
    }
  ]
});


// Add event listener to all blurred buttons
document.querySelectorAll('.blurred-button').forEach((button) => {
    button.addEventListener('click', () => {
        const video = button.closest('.blogBannerBtnWrap').previousElementSibling.querySelector('.custom-video'); // Select the corresponding video

        // Check for Fullscreen API compatibility and request fullscreen
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) { // Safari
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { // Internet Explorer/Edge
            video.msRequestFullscreen();
        }
    });
});

// Exit fullscreen on 'Esc' key press
document.addEventListener('fullscreenchange', () => {
    if (!document.fullscreenElement) {
        console.log('Exited fullscreen'); // Optional debug log
    }
});

// Compatibility for WebKit (Safari)
document.addEventListener('webkitfullscreenchange', () => {
    if (!document.webkitFullscreenElement) {
        console.log('Exited fullscreen'); // Optional debug log
    }
});

// Compatibility for MS (Internet Explorer/Edge)
document.addEventListener('msfullscreenchange', () => {
    if (!document.msFullscreenElement) {
        console.log('Exited fullscreen'); // Optional debug log
    }
});

document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll('.video-container');
  containers.forEach(container => initVideoPlayer(container));
});
  